<template>
    <v-dialog v-model="open_modal" persistent max-width="600px">
        <!-- Форма создания комплектубщей -->
        <v-card>
            <v-card-title>
                <span class="headline">Обновление Пользователя</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="12" md="12"
                        ><v-text-field
                            v-model="local_user.name"
                            name="input-10-1"
                            label="Введите Имя"
                            counter
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="12" md="12"> </v-col>
                </v-row>
            </v-card-text>

            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="12" md="12"
                        ><v-select v-model="local_user.title" :items="get_roles" label="Выберите Роль"></v-select>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="12" md="12"> </v-col>
                </v-row>
            </v-card-text>

            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="12" md="12"
                        ><v-select v-model="local_user.status" :items="get_statuses" label="Выберите Статус"></v-select>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="12" md="12"> </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close_modal()">Закрыть</v-btn>
                <v-btn color="warning" dark @click="save()">Сохранить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'EditUser',
    props: ['user', 'open_modal'],
    data() {
        return {
            dialog: null,
            show1: false,
            show2: false,
            password: '',
            password_confirm: '',
            local_user: JSON.parse(JSON.stringify(this.user)),
            get_roles: ['department', 'master', 'journalist', 'admin', 'worker'],
            get_statuses: ['department', 'user'],
        }
    },
    computed: {},
    methods: {
        ...mapActions(['update_user']),
        close_modal() {
            this.$emit('close', false)
        },
        save() {
            this.update_user({
                user: this.local_user,
            })
                .then(() => {
                    this.close_modal()
                })
                .catch((err) => {
                    console.log(err.response.message)
                })
        },
    },
}
</script>

<style scoped>
.user {
    border: 1px solid #ececec;
    width: 450px;
    margin-bottom: 30px;
    cursor: pointer;
    background: #fff;
    transition: box-shadow ease-out 0.2s;
    display: grid;
    grid-template-columns: 150px auto;
    grid-template-rows: 50% 50%;
    grid-template-areas: 'image name' 'image profession';
}

.user:hover {
    background: #fafafa;
    box-shadow: 6px 6px 24px rgba(0, 0, 0, 0.25);
}

.user img {
    width: 150px;
    grid-area: image;
}

.user .user__name {
    grid-area: name;
    margin-left: 15px;
    align-self: end;
    color: #383838;
    font-weight: 700;
    font-size: 16px;
}

.user .user__profession {
    grid-area: profession;
    margin-left: 15px;
    color: #777;
    font-size: 14px;
}
</style>